<a *ngIf="params.node.group">{{getValue()}}</a>

<button *ngIf="!params.node.group && params && params.data" class="{{getClass()}}">{{getValue()}}</button>
